import { refs, domReady, dispatchEvent, booleanDataset } from '../modules/utils.js';

class ProductVariants extends HTMLElement {
  static get observedAttributes() {
    return ['data-variant-id', 'data-price'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-variant-id') {
      dispatchEvent('productvariants:variant', { id: newValue });
      this?.refs?.values?.forEach((el) => {
        booleanDataset(el, 'active', el.dataset.id === newValue);
      });
    }
    if (name === 'data-price') {
      dispatchEvent('productvariants:price', { price: newValue });
    }
  }

  async connectedCallback() {
    await domReady();
    this.refs = refs(this);
    this.#listeners();
  }

  #listeners() {
    this.refs.values?.forEach((el) => {
      el.addEventListener('click', () => {
        const input = el.querySelector('input[type="radio"]');
        if (input) {
          input.checked = true;
          this.dataset.variantId = input.value;
          if (input.dataset.price) {
            this.dataset.price = input.dataset.price;
          }
        }
      });
    });
  }
}

customElements.define('product-variants', ProductVariants);
